<glxy-table-container
  [dataSource]="tableDataSource"
  [columns]="columns"
  [showFooter]="false"
  [border]="!config.hideBorder"
>
  <mat-table>
    <mat-header-row *matHeaderRowDef="[]" />
    <ng-container matColumnDef="name">
      <mat-header-cell class="name-column-label" *matHeaderCellDef>
        {{ 'ITEM_PRICING_TABLE.COLUMNS.ITEM' | translate }}
      </mat-header-cell>
      <mat-cell class="name-column" *matCellDef="let item">
        <div class="cell-top">
          <inventory-ui-item-label
            [item]="{
              itemId: item?.itemId,
              name: item?.name,
              editionName: item?.edition?.name,
              iconUrl: item?.iconUrl,
              subtext:
                config.billingTermsEnabled && item?.billingTerm
                  ? (item?.billingTerm | formatBillingTerm: item?.retailPricing?.frequency)
                  : ''
            }"
            [showItemId]="false"
            [showEditionName]="true"
          >
            <inventory-ui-package-contents-popover
              *ngIf="item?.type === 'package'"
              [packageId]="item?.itemId"
              [partnerId]="config.partnerId"
              [marketId]="config.marketId"
            />
          </inventory-ui-item-label>
        </div>
        <div class="cell-bottom fee label">
          <div class="item-fees label" *ngFor="let fee of item.fees">
            <ng-container *ngIf="fee.type === 'setup' || showManagementFees">
              <mat-icon class="fee-icon">subdirectory_arrow_right</mat-icon>
              <span>{{ fee.label }}</span>
            </ng-container>
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <mat-header-cell class="quantity-column-label" *matHeaderCellDef>
        {{ 'ITEM_PRICING_TABLE.COLUMNS.QUANTITY' | translate }}
      </mat-header-cell>
      <mat-cell class="quantity-column" *matCellDef="let item" data-cy="item-quantity-cell">
        <div class="cell-top">
          @if (config?.quantityEditable && item.isMultiactivatable && item.type === 'addon') {
            <glxy-form-field>
              <input
                matInput
                dense
                type="number"
                min="1"
                [value]="item.quantity"
                (change)="onQuantityChange($event, item)"
              />
            </glxy-form-field>
          } @else {
            <span class="quantity">{{ item.quantity }}</span>
          }
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="wholesale_price">
      <mat-header-cell class="pricing-column-label" *matHeaderCellDef>
        {{ 'ITEM_PRICING_TABLE.COLUMNS.WHOLESALE' | translate }}
      </mat-header-cell>
      <mat-cell class="pricing-column" *matCellDef="let item">
        <div>
          <div class="cell-top" [ngClass]="{ 'input-box': item.wholesalePricing.usesVariablePricing }">
            <billing-ui-simple-price-display
              *ngIf="item.wholesalePricing.usesVariablePricing !== true; else wholesaleSpend"
              class="item-pricing"
              [align]="'end'"
              [prices]="item.wholesalePricing.frequencyPrices"
              [currencyCode]="item.wholesalePricing.currency"
              [contactSales]="item.wholesalePricing.contactSales"
              [discounts]="item.wholesalePricing.discounts"
              data-cy="wholesale-price-display"
            />
            <ng-template #wholesaleSpend>
              <glxy-currency-field
                *ngFor="let frequencyPrice of item.wholesalePricing.frequencyPrices"
                [value]="frequencyPrice.price | centsToDollars"
                [currencyCode]="frequencyPrice.currency"
                [minimumValue]="'0'"
                [validators]="frequencyPrice.minimumPrice | centsToDollars | priceValidator"
                [hint]="frequencyPrice.minimumPrice | price: frequencyPrice.currency | formatWholesaleMinimumHint"
                [suffixText]="frequencyPrice.frequency | glxyFrequency"
                [maxWidth]="220"
                (change)="onPriceChange($event, item, 'wholesale', frequencyPrice.frequency)"
                [bottomSpacing]="'none'"
                data-cy="wholesale-spend"
              />
            </ng-template>
          </div>
          <div class="cell-bottom">
            <ng-container *ngFor="let fee of item.fees">
              <billing-ui-simple-price-display
                class="item-fees simple-price-display"
                *ngIf="fee.wholesaleAmount > 0; else noFee"
                [align]="'end'"
                [price]="fee.wholesaleAmount"
                [currencyCode]="item.wholesalePricing.currency"
                [frequency]="fee.type === 'setup' ? Frequency.ONE_TIME : item.wholesalePricing.frequency"
              />
            </ng-container>
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="retail_price">
      <mat-header-cell class="pricing-column-label" *matHeaderCellDef>
        {{ 'ITEM_PRICING_TABLE.COLUMNS.RETAIL' | translate }}
      </mat-header-cell>
      <mat-cell class="pricing-column" *matCellDef="let item">
        <div>
          <div class="cell-top input-box">
            <glxy-currency-field
              [value]="item.retailPricing.price | centsToDollars"
              [currencyCode]="item.retailPricing.currency"
              [minimumValue]="'0'"
              [suffixText]="showRetailFrequencySuffix ? (item.retailPricing.frequency | glxyFrequency) : undefined"
              [maxWidth]="220"
              (change)="onPriceChange($event, item, 'retail', item.retailPricing.frequency)"
              [bottomSpacing]="'none'"
              data-cy="retail-price"
            />
          </div>
          <div class="cell-bottom">
            <ng-container *ngFor="let fee of item.fees">
              <glxy-currency-field
                *ngIf="fee.retailAmount >= 0; else noFee"
                [value]="fee.retailAmount | centsToDollars"
                [currencyCode]="item.retailPricing.currency"
                [minimumValue]="'0'"
                [maxWidth]="220"
                (change)="onPriceChange($event, item, 'setupfee')"
                [bottomSpacing]="'none'"
                data-cy="retail-fee"
              />
            </ng-container>
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="retail_frequency">
      <mat-header-cell class="frequency-column-label" *matHeaderCellDef>
        {{ 'ITEM_PRICING_TABLE.COLUMNS.FREQUENCY' | translate }}
      </mat-header-cell>
      <mat-cell class="frequency-column" *matCellDef="let item">
        <div class="cell-top input-box">
          <inventory-ui-frequency-selector
            [selectedFrequency]="item.retailPricing.frequency"
            class="frequency-selector"
            (frequencySelectionChange)="handleFrequencyChange($event, item)"
          />
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="retail_price_total">
      <mat-header-cell class="pricing-column-label total" *matHeaderCellDef>
        {{ 'ITEM_PRICING_TABLE.COLUMNS.RETAIL_TOTAL' | translate }}
      </mat-header-cell>
      <mat-cell class="pricing-column total" *matCellDef="let item">
        <div>
          <div class="cell-top">
            <billing-ui-simple-price-display
              class="item-pricing"
              [align]="'end'"
              [price]="item.retailPricing.total"
              [currencyCode]="item.retailPricing.currency"
              [frequency]="item.retailPricing.frequency"
            />
          </div>
          <div class="cell-bottom">
            <ng-container *ngFor="let fee of item.fees">
              <billing-ui-simple-price-display
                class="item-fees"
                *ngIf="fee.retailAmountTotal > 0; else noFee"
                [align]="'end'"
                [price]="fee.retailAmountTotal"
                [currencyCode]="item.retailPricing.currency"
                [frequency]="Frequency.ONE_TIME"
              />
            </ng-container>
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="menu">
      <mat-header-cell class="menu-column" *matHeaderCellDef />
      <mat-cell class="menu-column" *matCellDef="let item">
        <div>
          <div class="cell-top menu">
            <button mat-icon-button [matMenuTriggerFor]="menu" data-cy="menu-trigger">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                *ngIf="config.billingTermsEnabled"
                class="edit-billing-terms"
                mat-menu-item
                (click)="publishChanges(item, 'edit-billing-term')"
              >
                {{ 'ITEM_PRICING_TABLE.ACTION_MENU.EDIT_BILLING_TERMS' | translate }}
              </button>
              <button
                *ngIf="config.billingTermsEnabled && item.billingTerm"
                class="add-billing-terms"
                mat-menu-item
                (click)="publishChanges(item, 'add-billing-term')"
              >
                {{ 'ITEM_PRICING_TABLE.ACTION_MENU.ADD_BILLING_TERMS' | translate }}
              </button>
              <button
                mat-menu-item
                (click)="addSetupFee(item)"
                [disabled]="item.fees | hasSetupFee"
                data-cy="add-setup-fee"
              >
                {{ 'ITEM_PRICING_TABLE.ACTION_MENU.ADD_SETUP_FEE' | translate }}
              </button>
              <button mat-menu-item (click)="resetItemPricing(item)" data-cy="reset-to-default">
                {{ 'ITEM_PRICING_TABLE.ACTION_MENU.RESET_TO_DEFAULT' | translate }}
              </button>
              @if (config?.selectionEditable) {
                <button mat-menu-item (click)="onRemoveItem(item)">
                  {{ 'ITEM_PRICING_TABLE.ACTION_MENU.REMOVE_ITEM' | translate }}
                </button>
              }
            </mat-menu>
          </div>

          <ng-container *ngFor="let fee of item.fees">
            <div class="cell-bottom close" *ngIf="fee | isSetupFeeRemovable">
              <button mat-icon-button (click)="removeSetupFee(item, fee)" data-cy="remove-setup-fee">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </ng-container>
        </div>
      </mat-cell>
    </ng-container>
    <mat-row *matRowDef="let row; columns: []" />
  </mat-table>

  @if (!config?.hidePriceSummary) {
    <ng-container *ngIf="priceTotals$ | async as total">
      <ng-container *ngIf="total.initialized; else loadingTotals">
        <div class="price-summary-footer">
          <div class="totals-row">
            <span>{{ 'ITEM_PRICING_TABLE.FOOTER.TOTALS' | translate }}</span>
          </div>

          <div class="row price-summary-row" data-cy="price-summary-footer">
            <div class="row price-row wholesale-row">
              <div>
                <span class="price-type-text">{{ 'ITEM_PRICING_TABLE.FOOTER.WHOLESALE' | translate }}</span>
              </div>
              <div class="price-display">
                <inventory-ui-price-summary-display [priceTotal]="wholesaleSummary" />
              </div>
            </div>

            <div class="row price-row retail-row">
              <div>
                <span class="price-type-text">{{ 'ITEM_PRICING_TABLE.FOOTER.RETAIL' | translate }}</span>
              </div>
              <div class="price-display">
                <inventory-ui-price-summary-display [priceTotal]="retailSummary" />
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  }

  <ng-template #noFee><div style="height: 20px; margin-bottom: 12px"></div></ng-template>
  <ng-template #loadingTotals><div class="stencil-shimmer loading-shimmer"></div></ng-template>
</glxy-table-container>
